// CustomCursor.js
import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import '../styles/CustomCursor.scss';

const CustomCursor = ({ onClick, isVisible }) => {
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;

    gsap.set(cursor, { xPercent: -50, yPercent: -50, opacity: 0 });

    const onMouseMove = (e) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.2,
        ease: 'power2.out',
      });
    };

    document.addEventListener('mousemove', onMouseMove);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, []);

  useEffect(() => {
    const cursor = cursorRef.current;

    if (isVisible) {
      gsap.to(cursor, { opacity: 1, duration: 0.3, ease: 'power2.out' });
    } else {
      gsap.to(cursor, { opacity: 0, duration: 0.3, ease: 'power2.out' });
    }
  }, [isVisible]);

  return (
    <div className="custom-cursor" ref={cursorRef} onClick={onClick}>
      Contact Us
    </div>
  );
};

export default CustomCursor;
